import { AddCircleOutline } from "@mui/icons-material";
import { Button, Divider } from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import CustomBotIcon from "../../../app/assets/custom-icons/CustomBotIcon.jsx";
import CoreBack from "../../../app/core/components/CoreBack/CoreBack";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton.jsx";
import CoreButtonHoverIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon.jsx";
import CoreDialog from "../../../app/core/components/CoreDialog/CoreDialog.jsx";
import CoreInputField from "../../../app/core/components/CoreInputField/CoreInputField.jsx";
import CoreSelectObjArr from "../../../app/core/components/CoreSelect/CoreSelectObjArr.jsx";
import CoreTabBar from "../../../app/core/components/CoreTabBar/CoreTabBar";
import { useGetAllPromptQuery } from "../../api/admin/aiPromptApi.js";
import {
  useCreateBotMutation,
  useDeleteBotMutation,
  useEditBotMutation,
  useGetAllBotQuery,
} from "../../api/admin/chatbotApi.js";
import DatasetTable from "./DatasetTable";
import UploadDocumentModal from "./UploadDocumentModal";

const SettingsChatBot = () => {
  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const [listsBots, setListsBots] = useState();
  const [clear, setClear] = useState(false);
  const [createMode, setCreateMode] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [selectedTab, setSelectedTab] = useState("Generali");
  const [formData, setFormData] = useState({
    aiPromptId: "",
    prompt: "",
    name: "",
    description: "",
  });

  const TABS_CHAT = [
    { label: "Generali", tab: "Generali" },
    { label: "Dataset", tab: "Dataset" },
  ];

  const { data: getAllBot } = useGetAllBotQuery({ withDocuments: true });
  const { data: promptList, isLoading: loadingPrompt } = useGetAllPromptQuery();

  const [createBot, { isLoading: loadingCreate }] = useCreateBotMutation();
  const [editBot, { isLoading: loadingEdit }] = useEditBotMutation();
  const [deleteBot, { isLoading: isDeleting }] = useDeleteBotMutation();

  const promptData = promptList?.Data?.value.prompts
    .filter((el) => el.service === "Agent")
    ?.map((prompt) => ({
      label: prompt.name,
      value: prompt.id,
    }));

  useEffect(() => {
    if (getAllBot && Array.isArray(getAllBot.agents)) {
      setListsBots(getAllBot.agents);
    }
  }, [getAllBot]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCompilerForm = (el) => {
    setFormData({
      id: el.id,
      aiPromptId: el.promptId,
      name: el.name,
      description: el.description,
    });
    setClear(true);
    setCreateMode(false);
  };

  const handleEmptyForm = () => {
    setFormData({
      aiPromptId: "",
      name: "",
      description: "",
    });
    setClear(false);
    setCreateMode(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
  };

  const handleDelete = () => {
    setOpenDeleteDialog(true);
  };

  const handleSave = () => {
    if (!formData.aiPromptId) {
      toast.error("Seleziona un prompt prima di salvare.");
      return;
    }
    try {
      if (clear) {
        const bodyEdit = {
          id: formData.id,
          name: formData.name,
          promptId: formData.aiPromptId,
          service: "Agent",
          description: formData.description,
        };
        editBot(bodyEdit)
          .unwrap()
          .then((res) => {
            toast.success(t("BotEdited"));
          })
          .catch(() => {
            toast.error(t("BotNotEdited"));
          });
      } else {
        const newBot = {
          name: formData.name,
          prompt: formData.prompt,
          description: formData.description,
          service: "Agent",
          promptId: formData.aiPromptId,
        };
        createBot(newBot)
          .unwrap()
          .then((res) => {
            toast.success(t("BotCreated"));
            handleEmptyForm();
          })
          .catch(() => {
            toast.error(t("BotNotCreated"));
          });
      }
    } catch (err) {
      toast.error(t("ReqErr"));
      console.log(err);
    }
  };

  const confirmDelete = () => {
    deleteBot(formData.id)
      .unwrap()
      .then(() => {
        toast.success(t("BotDeleted"));
        setOpenDeleteDialog(false);
      })
      .catch(() => {
        toast.error(t("BotNotDeleted"));
      });
  };

  const selectedBot = listsBots?.find((el) => el.id === formData.id);
  const selectedDocuments = selectedBot?.documents || [];

  return (
    <div className="w-full">
      <div className="flex ">
        <CoreBack />
        <CoreTabBar tab={TABS_CHAT} setSelectedTab={setSelectedTab} />
      </div>

      <p className="mb-0 font-bold">{t("SelectedAgentEdit")}</p>
      <div className="w-full flex space-x-8 mt-10">
        {/* Colonna selezione agente: SEMPRE visibile */}
        <div
          className="w-3/12 flex flex-col overflow-auto p-4 rounded-lg"
          style={{ border: "solid 1px lightgrey" }}
        >
          {listsBots?.map((el, i) => (
            <Button
              onClick={() => handleCompilerForm(el)}
              key={i}
              className={
                formData.id === el.id ? "ring-2 ring-primary ring-offset-2" : ""
              }
              style={{
                background: formData.id === el.id ? "#e3e8ff" : undefined,
                marginBottom: 8,
              }}
            >
              <div className="w-full flex items-center space-x-4 border-solid border border-zinc-400 p-2 rounded-lg">
                <CustomBotIcon className="w-20 h-20" shadows={false} />
                <h3 style={{ color: `${colorPrimary}` }}>{el.name}</h3>
              </div>
              <Divider />
            </Button>
          ))}
        </div>

        {/* PARTE CENTRALE: visibile solo se tab "generali" */}
        {selectedTab === "Generali" && (
          <div className="w-4/12 h-full space-y-4">
            <div className="flex justify-between items-center">
              <h3 className="p-2 ">
                {formData.aiPromptId !== ""
                  ? t("EditedAgent")
                  : t("CreatedAgent")}
              </h3>
              <div className="">
                {
                  <CoreButtonHoverIcon
                    onClick={handleEmptyForm}
                    className="m-1"
                    icon={<AddCircleOutline />}
                    testo={t("CreatedAgent")}
                  />
                }
              </div>
            </div>
            <CoreSelectObjArr
              className={""}
              name="aiPromptId"
              disabled={formData.aiPromptId === "" && !createMode}
              label="Seleziona Prompt"
              value={formData.aiPromptId}
              items={promptData || []}
              onChange={handleChange}
            />
            <CoreInputField
              className="w-full"
              disabled={formData.aiPromptId === "" && !createMode}
              label={t("Name")}
              name="name"
              onChange={handleChange}
              value={formData?.name}
            />
            <CoreInputField
              multiline
              rows={4}
              variant="outlined"
              disabled={formData.aiPromptId === "" && !createMode}
              className="w-full"
              label={t("Description")}
              name="description"
              onChange={handleChange}
              value={formData.description}
            />
            <div className="flex justify-around py-8 items-end ">
              {clear && (
                <CoreButton
                  onClick={handleDelete}
                  testo={t("Delete")}
                  className="btn-round bg-red-700 text-white border-red-700"
                />
              )}
              <CoreButton
                testo={t("Save")}
                className="bg-primary btn-round border-primary"
                onClick={handleSave}
                disabled={loadingCreate || loadingEdit || !formData.aiPromptId} // <-- disabilita se prompt non selezionato
              />
            </div>
          </div>
        )}
        {/* Fine parte centrale */}

        {/* PARTE DATASET: visibile solo se tab "dataset" */}
        {selectedTab === "Dataset" && (
          <div className="w-9/12 flex flex-col items-center mx-auto">
            <div className="mb-6 w-full">
              <p>{t("DataSetIntro")}</p>
              <div className="flex justify-start w-full">
                <Button
                  variant="outlined"
                  color="primary"
                  style={{ fontWeight: "bold" }}
                  onClick={() => setOpenUploadModal(true)}
                  disabled={!formData.id} // Disabilita se nessun bot selezionato
                >
                  Carica documento
                </Button>
              </div>
            </div>
            <DatasetTable documents={selectedDocuments} />
          </div>
        )}
      </div>

      <CoreDialog
        open={openDeleteDialog}
        title={t("Delete")}
        content={`${t("DeletingConfirm")} "${formData.name}"?`}
        positiveButton={t("Yes")}
        negativeButton={t("No")}
        handlePositive={confirmDelete}
        closeDialog={handleCloseDeleteDialog}
        disabledButton={isDeleting}
      />

      <UploadDocumentModal
        open={openUploadModal}
        onClose={() => setOpenUploadModal(false)}
        agentId={formData.id} // oppure idBot, a seconda di dove tieni l'id selezionato
        onUploadSuccess={() => {}}
      />
    </div>
  );
};

export default SettingsChatBot;
